<template>
  <div class="container">
    <div class="content">
      <div class="title"><h3>{{title}}</h3><a @click="changeMethod">切换({{inverseTitle}})</a></div>
      <div>
        <el-form :inline="true" :model="mcc" ref="mccForm">
          <div class="searchItem" v-if="isPositive">
          <el-form-item prop="mccType" :rules="[{
            required: isPositive,
            message: '请选择行业类型',
            trigger: 'change'
          }]">
            <el-select
              style="width:200px;"
              placeholder="全部行业"
              ref="mccType"
              clearable
              filterable
              v-model="mcc.mccType"
              @change="getGroup">
              <el-option v-for="item in mcc_list" :label="item.mccTxt" :value="item.mccCode" :key="item.mccCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="mccMiddle" :rules="[{
            required: isPositive,
            message: '请选择行业小类',
            trigger: 'change'
          }]">
            <el-select
              style="width:200px;"
              placeholder="行业小类"
              ref="mccMiddle"
              clearable
              filterable
              v-model="mcc.mccMiddle"
              @change="getMccDetails">
              <el-option v-for="item in mccMiddle_list" :label="item.mccTxt" :value="item.mccCode" :key="item.mccCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="mccCode" :rules="[{
            required: isPositive,
            message: '请选择详细类别',
            trigger: 'change'
          }]">
            <el-select
              style="width:200px;"
              placeholder="请选择详细类别"
              ref="mccCode"
              filterable
              clearable
              v-model="mcc.mccCode"
              @change="changeMccCode">
              <el-option v-for="item in group_list" :key="item.mccCode" :label="item.mccTxt" :value="item.mccCode" ></el-option>
            </el-select>
          </el-form-item>
          </div>
          <div class="searchItem" v-else>
          <el-form-item prop="mccCode" :rules="[{
            required: !isPositive,
            message: '请输入mccCode',
            trigger: 'change'
          }]">
            <el-input
                style="width:200px;"
                placeholder="请输入mccCode"
                clearable
                v-model="mcc.mccCode"
                v-if="!isPositive"
                @input="() => {this.showResult = false}">
              </el-input>
          </el-form-item>
          </div>
          <el-form-item>
            <el-button @click="onSubmit" :loading="searchLoading">查询</el-button>
          </el-form-item>
          </el-form>
      </div>
      <div class="result" v-show="showResult">
        <h4>结果</h4>
        <div class="resultItem"><span class="label">mccCode</span>{{mcc.mccCode}}</div>
        <div class="resultItem"><span class="label">行业</span>{{mcc.mccTypeResult}}</div>
        <div class="resultItem"><span class="label">行业小类</span>{{mcc.mccMiddleResult}}</div>
        <div class="resultItem"><span class="label">详细类别</span>{{mcc.mccCodeResult}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { getMcc, getMccByCode } from '@/api/global'
import { parseTime } from '@/utils/formatTime'
export default {
  data () {
    return {
      isPositive: true, // true: 通过行业分类查询mcc false: 根据mcc查询行业分类
      title: '根据行业分类查询商户mcc',
      inverseTitle: '根据mcc查询行业分类',
      mcc_list: [],
      mccMiddle_list: [],
      group_list: [],
      showResult: false,
      mcc: {
        mccType: '',
        mccMiddle: '',
        mccCode: '',
        mccTypeResult: '',
        mccMiddleResult: '',
        mccCodeResult: ''
      },
      searchLoading: false
    }
  },
  mounted () {
    this.getMcc(1, 0)// 获取行业类型
  },
  methods: {
    changeMethod () {
      [this.title, this.inverseTitle] = [this.inverseTitle, this.title]
      this.showResult = false
      this.isPositive = !this.isPositive
    },
    /**
     * @description 选中行业大类后获取行业小类列表
     * @param {Number} id 选中的大类id
     */
    getGroup (id) {
      this.showResult = false
      this.mcc.mccMiddle = ''
      this.mcc.mccCode = ''
      if (id) {
        this.$nextTick(() => {
          this.mcc.mccTypeResult = this.$refs.mccType.selectedLabel
        })
        this.getMcc(2, id)
      }
    },
    /**
     * @description 选中行业小类后获取行业详细类别列表
     * @param {Number} id 选中的小类id
     */
    getMccDetails (id) {
      this.showResult = false
      this.mcc.mccCode = ''
      if (id) {
        this.$nextTick(() => {
          this.mcc.mccMiddleResult = this.$refs.mccMiddle.selectedLabel
        })
        this.getMcc(3, id)
      }
    },
    /**
     * @description 行业大类和小类的列表获取
     */
    getMcc (level, id) {
      let params = {
        level: level
      }
      let listKey = ''
      if (level === 3 && id !== 0) {
        params.fatherCode = id
        this.mcc.mccCode = ''
        listKey = 'group_list'
      } else if (level === 2 && id !== 0) {
        params.fatherCode = id
        this.mcc.mccMiddle = ''
        listKey = 'mccMiddle_list'
      } else {
        listKey = 'mcc_list'
      }
      this[listKey] = []
      params = qs.stringify(params)
      getMcc(params).then(data => {
        if (data.result_cde === '0') {
          this[listKey] = data.data
        }
      })
    },
    changeMccCode () {
      this.showResult = false
      this.$nextTick(() => {
        this.mcc.mccCodeResult = this.$refs.mccCode.selectedLabel
      })
    },
    onSubmit () {
      this.$refs.mccForm.validate((valid) => {
        if (valid) {
          if (this.isPositive) {
            this.showResult = true
          } else {
            this.searchLoading = true
            const date = parseTime(new Date(), '{yy}{mm}{dd}{hh}{ii}')
            const params = qs.stringify({
              agentId: date,
              reqSerialNo: date,
              data: JSON.stringify({ mccCode: this.mcc.mccCode })
            })
            getMccByCode(params).then((res) => {
              this.searchLoading = false
              if (res.data.length) {
                const data = res.data[0]
                this.mcc.mccTypeResult = data.grandpaText
                this.mcc.mccType = data.grandpaCode
                this.mcc.mccMiddleResult = data.fatherText
                this.mcc.mccMiddle = data.fatherCode
                this.mcc.mccCodeResult = data.mccText
                this.showResult = true
              } else {
                this.$message({
                  showClose: true,
                  type: 'error',
                  message: 'mcc有误，无法查询对应行业信息'
                })
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
    background-color: #f0f2f5;
    .content{
      width:1000px;
      height:100%;
      overflow-y: auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      border-radius: 11px;
      background:rgba(255,255,255,1);
      padding: 30px;
      .title {
        margin-bottom: 30px;
        h3 {
          display: inline-block;
          margin-right: 30px;
        }
        a {
          color: #1482f0;
        }
      }
      .searchItem {
        display: inline-block;
      }
      .result {
        margin-top: 50px;
        .resultItem {
          margin-top: 15px;
        }
        .label {
          display: inline-block;
          width: 100px;
          margin-right: 10px;
        }
      }
    }
  }
</style>
